import React from 'react';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
export function LocationCard() {
  return <section id="location" className="py-24 bg-[#151515] border-t border-white/5" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-98">
          {/* Info Card */}
          <div className="bg-[#1a1a1a] p-8 md:p-12 rounded-sm border border-white/10 shadow-2xl" data-id="element-99">
            <h2 className="text-3xl font-bold text-white mb-8" data-id="element-100">
              Visit Our Shop
            </h2>

            <div className="space-y-8" data-id="element-101">
              <div className="flex items-start gap-4" data-id="element-102">
                <div className="p-3 bg-[#c41e3a]/10 rounded-full" data-id="element-103">
                  <MapPin className="w-6 h-6 text-[#c41e3a]" data-id="element-104" />
                </div>
                <div data-id="element-105">
                  <h3 className="text-white font-bold mb-1" data-id="element-106">Address</h3>
                  <p className="text-gray-400" data-id="element-107">1268 W. Central Ave</p>
                  <p className="text-gray-400" data-id="element-108">Davidsonville, MD 21035</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-109">
                <div className="p-3 bg-[#c41e3a]/10 rounded-full" data-id="element-110">
                  <Clock className="w-6 h-6 text-[#c41e3a]" data-id="element-111" />
                </div>
                <div data-id="element-112">
                  <h3 className="text-white font-bold mb-1" data-id="element-113">Hours</h3>
                  <div className="grid grid-cols-2 gap-x-8 gap-y-1 text-gray-400" data-id="element-114">
                    <span data-id="element-115">Mon - Fri</span>
                    <span className="text-white" data-id="element-116">8:00am - 6:00pm</span>
                    <span data-id="element-117">Saturday</span>
                    <span className="text-white" data-id="element-118">8:00am - 4:00pm</span>
                    <span data-id="element-119">Sunday</span>
                    <span className="text-[#c41e3a]" data-id="element-120">Closed</span>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-121">
                <div className="p-3 bg-[#c41e3a]/10 rounded-full" data-id="element-122">
                  <Phone className="w-6 h-6 text-[#c41e3a]" data-id="element-123" />
                </div>
                <div data-id="element-124">
                  <h3 className="text-white font-bold mb-1" data-id="element-125">Contact</h3>
                  <p className="text-gray-400 mb-2" data-id="element-126">
                    Ready to schedule your service?
                  </p>
                  <a href="tel:4107980900" className="text-2xl font-bold text-white hover:text-[#c41e3a] transition-colors" data-id="element-127">
                    (410) 798-0900
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="h-full min-h-[400px] bg-[#252525] rounded-sm overflow-hidden relative group" data-id="element-128">
            <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/qNyWcruiipFRdCRjaRU2dh/505822966_1188096186677831_6919732715312370453_n.jpg')] bg-cover bg-center opacity-50 grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-129" />
            <div className="absolute inset-0 flex items-center justify-center bg-black/40" data-id="element-130">
              <a href="https://maps.google.com/?q=1268+W+Central+Ave,+Davidsonville,+MD+21035" target="_blank" rel="noreferrer" className="px-8 py-4 bg-white text-black font-bold uppercase tracking-wider hover:bg-[#c41e3a] hover:text-white transition-colors shadow-lg" data-id="element-131">
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}